<template>
  <div>
    <!-- LIST START -->
    <template>
      <v-card max-width="300" tile>
        <v-list dense rounded>
          <v-subheader>{{selectedHappText}}</v-subheader>
          <v-list-item-group v-model="selectedListItem" color="orange">
            <v-list-item v-for="(item, i) in items" :key="i" @click="setSelectedHapp(item)">
              <!-- <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon> -->
              <v-list-item-content :color="item.Color">
                <v-row align="center">
                  <v-col cols="2">
                    <v-list-item-icon v-if="item.IsOpen">
                      <v-icon :color="item.Color">mdi-lock-open-variant-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon v-else>
                      <v-icon :color="item.Color">mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                  </v-col>
                  <v-col>
                    <v-list-item-title v-text="item.happShortName"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.HappName"></v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </template>
  </div>
</template>
<!-- LIST SLUTT -->

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedHapp: null,
      selectedHappText: null,
      items: [],
      currentitems:[],
      errors: [],
      regId: Number,
      ac: null,
      selectedListItem: -1,
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedHappText = "Select...";
    this.getCookies();
    this.gethappsforadmin();
  },

  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);
    },
    setSelectedHapp(Happ) {
      this.selectedHapp = Happ;
      this.selectedHappText = Happ.Happ;
      this.$emit("happ_changed", Happ);
    },
    gethappsforadmin() {
      var regId = this.regId;
      var ac = this.ac;
      var happId = 0;
      var hidden = -1;
      var toSubmit = { regId, ac, happId, hidden };
    //   console.log("toSubmit:", toSubmit);
      var apimethod = "happsforadmin"; //NB: Remember if (apimethod=="<apimethod>") in setDataArray
      var uri = this.baseUrl + apimethod;
    //   console.log("uri",uri)
      this.post(uri,toSubmit,apimethod);
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regId = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    post(uri, toSubmit,apimethod) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.currentitems = response.data;
          this.loading = false;
          console.log(this.currentitems);
          this.setDataArray(apimethod);
         }
        )
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setDataArray(apimethod)
    {
        if (apimethod == "happsforadmin")
        {
            this.items = this.currentitems;
        }

    },
  },
};
</script>